import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationkz from '../locales/app_kz.json';
import { setHTMLLang } from '../utils/seo';

const VALID_LANGUAGES = ['kz', 'ru', 'en', 'cn'];
const LANG_ALIASES = { kk: 'kz', zh: 'cn' };

/**
 * `?lang=` сілтемеде берілсе — бастапқы тіл сол болады.
 *
 * Тек useSyncLanguageFromQuery жеткіліксіз: Header өзінің currentLanguage
 * күйін монтажда localStorage-тен алады да, effect-інде тілді қайта орнатып,
 * хуктың changeLanguage-ін басып тастайды. Сондықтан таңдауды React рендерге
 * дейін, осы жерде жасаймыз — бүкіл қосымша бірден дұрыс тілде көтеріледі
 * (мыс. agroland.kz/business-offer?lang=ru сілтемесі).
 */
function languageFromQuery() {
    try {
        const raw = new URLSearchParams(window.location.search).get('lang');
        if (!raw) return null;
        const normalized = raw.toLowerCase().trim();
        const resolved = LANG_ALIASES[normalized] || normalized;
        return VALID_LANGUAGES.includes(resolved) ? resolved : null;
    } catch (e) {
        return null;
    }
}

const queryLanguage = languageFromQuery();
if (queryLanguage) {
    try {
        // `language` — Header оқитын кілт; `selectedLanguage` — тіл модалінікі.
        // Модаль монтажда елді анықтап, `selectedLanguage` бос болса тілді елге
        // қарай ауыстырады да, сілтемедегі таңдауды басып тастайды — сондықтан
        // екі кілтті де жазамыз.
        localStorage.setItem('language', queryLanguage);
        localStorage.setItem('selectedLanguage', queryLanguage);
    } catch (e) {
        // жеке режимде localStorage жабық болуы мүмкін — тіл бәрібір қолданылады
    }
}

const savedLanguage = queryLanguage || localStorage.getItem('language') || 'kz';

// kz (fallback) бандлда бірден бар; ru/en/cn керек болғанда ғана жеке chunk
// болып жүктеледі — changeLanguage жүктелуін күтіп барып ауысады.
const lazyLocaleBackend = {
    type: 'backend',
    init() {},
    read(language, namespace, callback) {
        if (!VALID_LANGUAGES.includes(language)) {
            callback(null, {});
            return;
        }
        import(`../locales/app_${language}.json`)
            .then((module) => callback(null, module.default))
            .catch((error) => callback(error, null));
    }
};

export const i18nReady = i18n
    .use(lazyLocaleBackend)
    .use(initReactI18next)
    .init({
        resources: {
            kz: { translation: translationkz }
        },
        partialBundledLanguages: true,
        lng: savedLanguage,
        fallbackLng: 'kz',
        interpolation: {
            escapeValue: false
        }
    });

setHTMLLang(savedLanguage);
i18n.on('languageChanged', (lng) => setHTMLLang(lng));

export default i18n;